import Vue from 'vue'

import { Button, Toast, RadioGroup, Radio, Form, Field, Tabbar, TabbarItem , Swipe, SwipeItem, Empty, Image as VanImage, Picker, Popup, DatetimePicker, List, PullRefresh, Uploader, Divider, Checkbox, CheckboxGroup, Calendar, Icon, Tab, Tabs, Dialog, Cell, CellGroup, Overlay, Sticky, Stepper, DropdownMenu, DropdownItem } from 'vant'

Vue.use(Button);
Vue.use(Toast);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Form);
Vue.use(Field);
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Empty);
Vue.use(VanImage);
Vue.use(Picker);
Vue.use(Popup);
Vue.use(DatetimePicker);
Vue.use(List);
Vue.use(PullRefresh);
Vue.use(Uploader);
Vue.use(Divider);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Calendar);
Vue.use(Icon);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Dialog);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Overlay);
Vue.use(Sticky);
Vue.use(Stepper);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);